// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{

  $('body').addClass('preload');

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  $("#st-Top").on("click", function(){
    var linkSpeed    = 800;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
    return false;
  });
};


export {
  preload,
  pageTop
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js